import { render, staticRenderFns } from "./InactiveInventory.vue?vue&type=template&id=5c627082&scoped=true"
import script from "./InactiveInventory.vue?vue&type=script&lang=js"
export * from "./InactiveInventory.vue?vue&type=script&lang=js"
import style0 from "./InactiveInventory.vue?vue&type=style&index=0&id=5c627082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c627082",
  null
  
)

export default component.exports